import { reactive, createVNode } from 'vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { Modal } from 'ant-design-vue';
import { notice } from '@/utils/index';

export const useTable = () => {
    // 请求配置
    const requestConfig = {
        pull_fn: null,
        delete_fn: null,
        uploadForm_fn: null,
    };

    // 请求参数
    const requestPayload = reactive({});
    // 初始化请求参数
    const initPayload = (payload) => {
        Object.keys(payload).forEach((key) => {
            requestPayload[key] = payload[key];
        });
    };
    // 表格数据
    const table = reactive({
        pageNum: 1,
        lineNum: 10,
        total: 0,
        data: [],
        loading: false,
    });

    // 获取数据的方法
    const getListData = (options) => {
        table.loading = true;

        const { unPagingRequest } = options || {};

        return new Promise((resolve, reject) => {

            let payload = requestPayload;

            if (!unPagingRequest) {
                payload = Object.assign(payload, {
                    pageNum: table.pageNum,
                    lineNum: table.lineNum,
                });
            }

            requestConfig.pull_fn(payload).then(res => {
                table.data.length = 0;
                const type = Object.prototype.toString.call(res.data);
                if (!unPagingRequest && type === '[object Object]' && res.data.records) {
                    table.data.push(...res.data.records);
                    table.total = res.data.total;
                } else if (type === '[object Array]') {
                    table.data.push(...res.data);
                } else if (type === '[object Object]') {
                    Object.keys(res.data).forEach((key) => {
                        table.data.push(...res.data[key])
                    });
                }
                table.loading = false;
                resolve('ok');
            }).catch(err => {
                table.loading = false;
                reject(err);
            })
        });
    };

    const searchData = () => {
        table.pageNum = 1;
        getListData();
    };

    /**
    * 删除数据
    * @params {Array<Number>} ids 删除的id
    * @params {string} optins.title 提示框标题
    */
    const deleteRecords = (ids, options) => {
        const { title } = options;
        return new Promise((resolve, reject) => {
            Modal.confirm({
                title,
                icon: createVNode(ExclamationCircleOutlined),
                content: '',
                okText: '是',
                okType: 'danger',
                cancelText: '否',
                centered: true,
                onOk() {
                    requestConfig.delete_fn(ids).then((res) => {
                        resolve('ok');
                        if (res.code === 200 && res.message === '删除成功') {
                            notice('success', '提示', '删除成功', 2);
                            // getListData();
                        } else if (res.code === 400) {
                            notice('error', '提示', res.message, 2);
                        }
                    }).catch((err) => {
                        reject('error')
                    });
                },
                onCancel() {
                    reject('cancel')
                },
            });
        });
    };

    const hanldeUpdatePageNum = (page, size) => {
        table.pageNum = page;
        table.lineNum = size;
        getListData();
    };

    return {
        requestConfig,
        table,
        requestPayload,
        initPayload,
        getListData,
        searchData,
        deleteRecords,
        hanldeUpdatePageNum,
    }
};
